import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import SidebarToggleIcon from '../SidebarToggleIcon';
import SearchIcon from '@material-ui/icons/SearchOutlined';
import MoreVertIcon from '@material-ui/icons/MoreHorizOutlined';
import AppsIcon from '@material-ui/icons/AppsOutlined';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Avatar,
  Typography,
  ListItemIcon,
} from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import logoImg from '../../../Assets/images/logo.jpg';
import logoDarkImg from '../../../Assets/images/logo-dark.svg';
import { logout, useAuthDispatch, useAuthState } from '../../../Context';
import NotificationsIcon from '@material-ui/icons/NotificationsNoneOutlined';
import userImg from '../../../Assets/images/loading-waiting.gif';
import defaultImage from '../../../Assets/images/customer-default-logo.png';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Paths, UserPath } from '../../../Routes/routePaths';
import EditIcon from '@material-ui/icons/EditOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Brightness4Icon from '@material-ui/icons/Brightness4Outlined';
import WbSunnyIcon from '@material-ui/icons/WbSunnyOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { useColorMode } from '../../../theme/ColorModeProvider';
import { UserServices, clearMyProfileCache, getCachedMyProfile, peekMyProfileCache } from '../../../Services/UserServices';
import { applyLearningHubFromProfile } from '../../../utils/learningHubAvailability';
import { useHistory, useLocation } from 'react-router';
import variables from '../../../Sys/variable.scss';
import { USER_ROLES } from '../../../utils/constants';
import DynamicAutoSearch from 'Components/DynamicAutoSearch';
import { CoursesServices } from 'Services/CoursesServices';
import { useContext } from 'react';
import { CourseContext } from 'Context/CourseProvider';
import { getEncodeURL } from 'utils';
import { useKeycloak } from "../../../Context/keyCloakProvider";
import { goToMoodleLogoutOrKeycloak } from '../../../utils/moodleSingleLogout';
import { useImpersonation } from '../../../hooks/useImpersonation';
import { endImpersonation } from '../../../Services/deviareAuth';
import { isImpersonating, resumeSuperadminReturnRedirect, suppressSuperadminReturnRedirect } from '../../../Services/impersonationSession';
import { notify } from '../../../utils';
import { resolveBrandLogo } from './brandLogo';
const userServices = new UserServices();
const coursesService = new CoursesServices();

const getBrandLogo = () =>
  resolveBrandLogo(localStorage.getItem('company_logo'), logoImg);

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 0,
    flexShrink: 0,
    position: 'sticky',
    top: 'var(--impersonation-banner-offset, 0px)',
    zIndex: theme.zIndex.appBar,
  },
  headerBar: {
    backgroundColor: variables.headerColor,
    height: 72,
    backgroundImage: 'linear-gradient(135deg, rgba(61, 125, 221, 0.08), transparent 48%)',
    boxShadow: '0 8px 24px rgba(12, 20, 36, 0.12)',
    position: 'relative',
    backdropFilter: 'blur(14px)',
    borderBottom: '1px solid var(--dm-border, rgba(0, 0, 0, 0.08))',
    [theme.breakpoints.down('sm')]: {
      height: 68,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    padding: theme.spacing(0, 3),
    boxSizing: 'border-box',
    minHeight: '72px !important',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      padding: theme.spacing(0, 2),
      minHeight: '68px !important',
    },
    '@media (max-width: 600px)': {
      padding: theme.spacing(0, 1),
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: variables.darkThemeText || '#fff',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    width: 44,
    height: 44,
    borderRadius: 12,
    border: '1px solid var(--dm-border, rgba(255,255,255,.12))',
    backgroundColor: 'rgba(61, 125, 221, 0.08)',
    transition: 'background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.16)',
      borderColor: 'rgba(61, 125, 221, 0.35)',
      transform: 'translateY(-1px)',
    },
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      marginRight: theme.spacing(1),
    },
    '@media (max-width: 600px)': {
      width: 40,
      height: 40,
      marginRight: theme.spacing(0.5),
    },
  },
  brandLogoWrap: {
    flex: '0 0 auto',
    width: 140,
    maxWidth: 140,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 100,
      maxWidth: 100,
    },
    '@media (max-width: 600px)': {
      width: 84,
      maxWidth: 84,
    },
  },
  title: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexGrow: 0,
      marginRight: theme.spacing(1),
      flex: '0 0 auto',
    },
  },
  userTitle: {
    flex: '0 0 auto',
    flexGrow: 0,
  },
  logo: {
    cursor: 'pointer',
    width: '100%',
    maxWidth: 140,
    height: 'auto',
    maxHeight: 48,
    objectFit: 'contain',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 100,
      maxHeight: 36,
    },
    '@media (max-width: 600px)': {
      maxWidth: 84,
      maxHeight: 32,
    },
  },
  logoAdmin: {
    cursor: 'pointer',
    width: '100%',
    maxWidth: 140,
    height: 'auto',
    maxHeight: 48,
    objectFit: 'contain',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 100,
      maxHeight: 36,
    },
  },
  searchBar: {
    flexGrow: 1,
    marginLeft: theme.spacing(3),
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
    maxWidth: 520,
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  searchBarMobile: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#fff',
      padding: theme.spacing(1.5, 2),
      zIndex: 1000,
      boxShadow: '0 8px 24px rgba(12, 41, 84, 0.1)',
      borderTop: '1px solid #e7ebf0',
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
  },
  searchIconButton: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: '0 0 auto',
      width: 40,
      height: 40,
      borderRadius: 8,
      color: variables.darkThemeText,
      transition: 'background-color 0.15s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    '@media (max-width: 600px)': {
      width: 36,
      height: 36,
      marginLeft: theme.spacing(0.5),
    },
  },
  searchIconButtonActive: {
    backgroundColor: 'rgba(61, 125, 221, 0.08)',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.12)',
    },
  },
  exploreButton: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8125rem',
    padding: theme.spacing(0.875, 2.5),
    borderRadius: 8,
    transition: 'background-color 0.15s ease, border-color 0.15s ease',
    border: `1px solid ${variables.sidebarActive || 'rgba(60, 125, 221, 0.35)'}`,
    color: variables.darkThemeText,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      borderColor: variables.sidebarActive,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  exploreButtonOpen: {
    backgroundColor: 'rgba(61, 125, 221, 0.08)',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.12)',
      borderColor: theme.palette.primary.main,
    },
  },
  explorePanel: {
    width: '100%',
    backgroundColor: '#fff',
    marginTop: 8,
    padding: theme.spacing(2.5, 3),
    boxShadow: '0 8px 24px rgba(12, 41, 84, 0.1)',
    borderRadius: 8,
    border: '1px solid #e7ebf0',
    maxHeight: '85vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 'none',
      padding: theme.spacing(2),
      maxHeight: '80vh',
      boxSizing: 'border-box',
    },
  },
  explorePanelHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #e7ebf0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(1.5),
    },
  },
  explorePanelEyebrow: {
    color: theme.palette.primary.main,
    fontSize: '0.6875rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: theme.spacing(0.5),
  },
  explorePanelTitle: {
    color: '#263548',
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: 1.35,
  },
  explorePanelDescription: {
    color: '#647184',
    fontSize: '0.8125rem',
    lineHeight: 1.5,
    marginTop: 2,
    maxWidth: 420,
  },
  exploreButtonMobile: {
    display: 'none',
    fontSize: '0.875rem',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flex: '0 0 auto',
      marginLeft: theme.spacing(0.5),
      width: 40,
      height: 40,
      borderRadius: 8,
      color: variables.darkThemeText,
      transition: 'background-color 0.15s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileIconsGroup: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      marginLeft: 'auto',
      flex: '0 0 auto',
    },
  },
  iconBtn: {
    width: 38,
    height: 38,
    padding: 0,
    borderRadius: 10,
    border: '1px solid var(--dm-border, #dfe5ec)',
    backgroundColor: 'var(--contentColor, #fff)',
    color: 'var(--dm-muted, #526174)',
    boxShadow: '0 1px 2px rgba(12, 41, 84, 0.04)',
    transition: 'background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease',
    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem',
    },
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.08)',
      borderColor: 'rgba(61, 125, 221, 0.45)',
      color: theme.palette.primary.main,
      boxShadow: '0 3px 10px rgba(61, 125, 221, 0.12)',
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 auto',
      display: 'flex',
      justifyContent: 'center',
    },
    '@media (max-width: 600px)': {
      width: 36,
      height: 36,
      borderRadius: 9,
    },
  },
  userMobileUtility: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  desktopBrandHidden: {
    '@media (min-width: 1280px)': {
      display: 'none',
    },
  },
  profileAvatarButton: {
    [theme.breakpoints.up('sm')]: { display: 'none' },
  },
  profileAvatar: {
    width: 30,
    height: 30,
    border: '1px solid var(--dm-border, #dfe5ec)',
    boxShadow: '0 1px 4px rgba(12, 41, 84, 0.12)',
  },
  profileMenuPaper: {
    width: 260,
    borderRadius: 14,
    border: '1px solid var(--dm-border, #e7ebf0)',
    boxShadow: '0 18px 48px rgba(12, 20, 36, 0.2)',
    overflow: 'hidden',
    backgroundColor: 'var(--contentColor, #fff)',
  },
  profileMenuHeader: {
    width: '100%',
    padding: theme.spacing(2, 2, 1.75),
    borderBottom: '1px solid var(--dm-border, #e7ebf0)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'var(--dm-row-alt, #f8fafc)',
  },
  profileImg: {
    width: 72,
    height: 72,
    margin: '0 auto',
    overflow: 'hidden',
    border: '1px solid var(--dm-border, #e7ebf0)',
    borderRadius: '50%',
    backgroundColor: 'var(--contentColor, #fff)',
    position: 'relative',
  },
  largeImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  editBack: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    background: 'rgba(38, 53, 72, 0.72)',
    backdropFilter: 'blur(4px)',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      background: 'rgba(38, 53, 72, 0.88)',
    },
  },
  profileMenuName: {
    marginTop: theme.spacing(1.25),
    color: 'var(--dm-text-strong, #263548)',
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.3,
    textAlign: 'center',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  profileMenuEmail: {
    marginTop: 2,
    color: 'var(--dm-muted, #647184)',
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.35,
    textAlign: 'center',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  profileMenuList: {
    padding: theme.spacing(1),
  },
  profileMenuItem: {
    color: '#263548',
    borderRadius: 8,
    margin: theme.spacing(0.25, 0),
    padding: theme.spacing(1, 1.25),
    fontSize: '0.8125rem',
    fontWeight: 600,
    minHeight: 40,
    transition: 'background-color 0.15s ease, color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.08)',
      color: theme.palette.primary.main,
    },
  },
  profileMenuItemIcon: {
    minWidth: 32,
    color: 'inherit',
    '& .MuiSvgIcon-root': {
      fontSize: '1.125rem',
    },
  },
  profileMenuItemLogout: {
    color: '#c62828',
    '&:hover': {
      backgroundColor: 'rgba(198, 40, 40, 0.08)',
      color: '#b71c1c',
    },
  },
  rightMenuItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginLeft: 'auto',
    padding: theme.spacing(0, 1.5),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  navSectionLink: {
    fontWeight: 500,
    fontSize: '0.875rem',
    padding: theme.spacing(0.5, 1),
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    color: variables.darkThemeText,
    textDecoration: 'none',
    '&:hover': {
      color: '#3C7DDD',
    },
  },
  navSectionLinkActive: {
    color: '#3C7DDD',
    '&:hover': {
      color: '#3C7DDD',
    },
  },
  mobileNavMenuItem: {
    fontSize: '0.875rem',
    fontWeight: 500,
    padding: theme.spacing(1.25, 2),
    borderRadius: 8,
    margin: theme.spacing(0.25, 1),
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(60, 125, 221, 0.08)',
    },
  },
  mobileNavMenuItemActive: {
    color: '#3C7DDD',
    backgroundColor: 'rgba(60, 125, 221, 0.12)',
    '&:hover': {
      backgroundColor: 'rgba(60, 125, 221, 0.18)',
    },
  },
  mobileMenuButton: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flex: '0 0 auto',
      marginLeft: theme.spacing(0.5),
    },
  },
  mobileMenuPaper: {
    marginTop: theme.spacing(1.5),
    minWidth: 200,
    borderRadius: 8,
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    padding: theme.spacing(0.5),
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.75),
      marginLeft: 'auto',
      flex: '0 0 auto',
      justifyContent: 'flex-end',
    },
    '@media (max-width: 600px)': {
      gap: theme.spacing(0.5),
    },
  },
  profileButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(0.375, 1.25, 0.375, 0.5),
    minHeight: 38,
    borderRadius: 10,
    border: '1px solid var(--dm-border, rgba(0, 0, 0, 0.08))',
    backgroundColor: 'var(--contentColor, #fff)',
    color: variables.darkThemeText,
    maxWidth: 240,
    overflow: 'hidden',
    transition: 'background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.08)',
      borderColor: 'rgba(61, 125, 221, 0.45)',
      boxShadow: '0 3px 10px rgba(61, 125, 221, 0.12)',
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  profileButtonText: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: variables.darkThemeText,
    maxWidth: 160,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '@media (max-width: 1440px)': {
      maxWidth: 112,
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
    },
  },
  menuContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    backgroundColor: 'transparent',
    gap: theme.spacing(2),
    alignItems: 'stretch',
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
    },
  },
  menuContainerItem: {
    margin: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.75),
    borderRadius: 8,
    border: '1px solid #e7ebf0',
    backgroundColor: '#f8fafc',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      borderColor: '#d5dde8',
      boxShadow: '0 2px 10px rgba(12, 41, 84, 0.06)',
      backgroundColor: '#fff',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(1.5),
    },
  },
  categoryHeaderRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25),
  },
  header: {
    fontSize: '0.8125rem',
    fontWeight: 700,
    color: '#263548',
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem',
    },
  },
  categoryCount: {
    flexShrink: 0,
    minWidth: 22,
    height: 22,
    padding: '0 6px',
    borderRadius: 999,
    backgroundColor: '#e7ebf0',
    color: '#647184',
    fontSize: '0.6875rem',
    fontWeight: 700,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  menuSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(0.25),
    flex: 1,
  },
  courseLink: {
    color: '#647184',
    cursor: 'pointer',
    fontSize: '0.8125rem',
    fontWeight: 500,
    padding: theme.spacing(0.75, 1),
    textAlign: 'left',
    justifyContent: 'flex-start',
    textTransform: 'none',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    minHeight: 'auto',
    minWidth: 0,
    width: '100%',
    lineHeight: 1.4,
    borderRadius: 6,
    transition: 'background-color 0.15s ease, color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.08)',
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      padding: theme.spacing(0.75, 0.875),
    },
  },
  viewAll: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '0.8125rem',
    fontWeight: 600,
    textTransform: 'none',
    padding: theme.spacing(0.75, 1),
    marginTop: theme.spacing(0.5),
    justifyContent: 'flex-start',
    minWidth: 0,
    borderRadius: 6,
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.08)',
      textDecoration: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
    },
  },
  lastRow: {
    gridColumn: '1 / -1',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
    paddingTop: theme.spacing(2),
    borderTop: '1px solid #e7ebf0',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'stretch',
      width: '100%',
    },
  },
  browseAll: {
    color: '#fff',
    backgroundColor: theme.palette.primary.main,
    cursor: 'pointer',
    padding: theme.spacing(1.25, 3),
    borderRadius: 8,
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    boxShadow: 'none',
    border: 'none',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark || '#356fc4',
      boxShadow: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(1.25, 2),
    },
  },
}));

export const TopBarButton = ({
  name,
  icon,
  layout,
  path,
  button = false,
  activeClassName = 'active'
}) => (
  <NavLink
    to={layout + path}
    activeClassName={activeClassName}
    exact
    id="topBar_nav">
    <Button
      color={button ? 'primary' : 'secondary'}
      variant={button ? 'contained' : 'default'}
      size="large"
      id="topBar_button">
      <span id="topBar_span">
        <i className={icon} />
      </span>
      <span> {name} </span>
    </Button>
  </NavLink>
);

const Header = ({ onMenuClick, showHamburger = false, desktopLogoInSidebar = false }) => {
  const { mode, toggleColorMode } = useColorMode();
  const { keycloak, setAuthenticated } = useKeycloak();
  const impersonation = useImpersonation();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTinyScreen = useMediaQuery('(max-width:374px)');
  const isCompactMobile = useMediaQuery('(max-width:600px)');
  const history = useHistory();
  const location = useLocation();
  const isNavItemActive = (path) => {
    if (path === Paths.Dashboard) return location.pathname === Paths.Dashboard;
    if (path.includes('inprogress')) return location.pathname === UserPath.RegisteredCourses && location.search.includes('inprogress');
    if (path.includes('completed')) return location.pathname === UserPath.RegisteredCourses && location.search.includes('completed');
    return false;
  };
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const anchorRef = React.useRef(null);
  const avatarAnchorRef = React.useRef(null);
  const [logoUrl, setLogoUrl] = useState(getBrandLogo);
  const [searchCourses, setSearchCourses] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [optLoading, setOptLoading] = useState('not');
  const [otherImgWidth, setOtherImgWidth] = useState(0);
  const { courseCatalogues } = useContext(CourseContext);

  const dispatch = useAuthDispatch();
  const { userDetails } = useAuthState(dispatch);
  const menuRef = React.useRef(null);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const mobileMenuAnchorRef = React.useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const menu_items = [
    { name: 'Dashboard', path: Paths.Dashboard },
    {
      name: 'In-progress',
      path: UserPath.RegisteredCourses + '?type=inprogress'
    },
    { name: 'Completed', path: UserPath.RegisteredCourses + '?type=completed' }
  ];
  const [loading, setLoading] = useState(true);
  const [courseCatalogueList, setCourseCatalogueList] = useState([]);
  const [userRole, setUserRole] = useState(USER_ROLES.USER);
  const [globalSearchVal, setGlobalSearchVal] = useState('');

  React.useEffect(() => {
    if (!courseCatalogues?.status) {
      return;
    }
    const filterCategories = Array.isArray(courseCatalogues.filters?.categories)
      ? courseCatalogues.filters.categories.filter((name) => name)
      : [];
    if (filterCategories.length) {
      setCourseCatalogueList(filterCategories.map((name) => ({ category: name })));
    } else if (Array.isArray(courseCatalogues.data)) {
      setCourseCatalogueList(courseCatalogues.data);
    }
    setLoading(false);
  }, [courseCatalogues]);

  const handleToggleMenu = () => {
    setMenuOpen(prevOpen => !prevOpen);
  };

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const handleMobileMenuItemClick = (path) => {
    history.push(path);
    handleMobileMenuClose();
  };

  React.useEffect(() => {
    if (userDetails) {
      const getRole = localStorage.getItem('role').trim();
      getUserProfile();
      setUserRole(getRole || USER_ROLES.USER);
      if (window.location.hostname !== 'platform.deviare.africa') {
        setLogoUrl(getBrandLogo());
        setOtherImgWidth(85);
      }
    }
  }, [userDetails, impersonation.active]);

  const getUserProfile = async () => {
    const existing = peekMyProfileCache();
    if (existing) {
      setLoggedInUser(existing);
      applyLearningHubFromProfile(existing);
      return;
    }
    setProfileLoading(true);
    try {
      const profile = await getCachedMyProfile(userServices);
      if (profile) {
        setLoggedInUser(profile);
        applyLearningHubFromProfile(profile);
        if (!isImpersonating()) {
          localStorage.setItem('comp_ids', profile.uuid);
        }
      }
    } finally {
      setProfileLoading(false);
    }
  };

  const handleLogout = async () => {
    if (isImpersonating()) {
      suppressSuperadminReturnRedirect();
      const ended = await endImpersonation();
      if (!ended.ok) {
        resumeSuperadminReturnRedirect();
        notify('error', ended.message || 'Return to the superadmin account before logging out.');
        return;
      }
    }
    setAuthenticated(false);
    await logout(dispatch);
    clearMyProfileCache();
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });
    goToMoodleLogoutOrKeycloak(keycloak);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    const currentAnchor = isMobile ? avatarAnchorRef.current : anchorRef.current;
    if (currentAnchor && currentAnchor.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleProfile = () => {
    history.push(Paths.Profile);
  };

  const handleChangePassword = () => {
    history.push(Paths.ChangePassword);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleGlobalSearch = async value => {
    setGlobalSearchVal(value);
  };

  React.useEffect(() => {
    if (!globalSearchVal) {
      setSearchCourses([]);
    } else {
      const getData = setTimeout(async () => {
        getSearchCourseList(globalSearchVal);
      }, 500);
      return () => clearTimeout(getData);
    }
  }, [globalSearchVal]);

  const getSearchCourseList = async searchVal => {
    setOptLoading('');
    const courseList = await coursesService.getEcommerceCourses(
      searchVal ? `name=${searchVal}` : ''
    );
    if (courseList.status && courseList.data) {
      const courses = [];
      courseList.data.forEach(itm => {
        itm.courses.forEach(cs => {
          if (courses.length < 11) {
            courses.push({ ...cs, category: cs.category || itm.category });
          }
        });
      });
      setSearchCourses(courses);
    }
    setOptLoading('not');
  };

  const handleSubManuClicked = itm => {
    setMenuOpen(false);
    history.push(
      itm
        ? getEncodeURL(`${UserPath.CourseCatalogue}?category=${itm.category}`)
        : UserPath.CourseCatalogue
    );
  };

  const useDarkBrand = mode === 'dark' && (!logoUrl || logoUrl === 'null' || logoUrl === logoImg);
  const brandLogo = useDarkBrand ? logoDarkImg : logoUrl;
  const profileImageSrc = profileLoading
    ? userImg
    : loggedInUser && loggedInUser.profile_image
      ? loggedInUser.profile_image
      : defaultImage;
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.headerBar}>
        <Toolbar className={classes.toolbar}>
          {showHamburger && (
            <IconButton
              data-testid="hamburger-menu"
              color="inherit"
              aria-label="open drawer"
              onClick={onMenuClick}
              className={classes.menuButton}
            >
              <SidebarToggleIcon />
            </IconButton>
          )}
          {userRole === USER_ROLES.USER ? (
            <>
              <div className={`${classes.title} ${classes.userTitle}`}>
                <div className={`${classes.brandLogoWrap}${desktopLogoInSidebar ? ` ${classes.desktopBrandHidden}` : ''}`}>
                  <img
                    loading="eager"
                    className={`${classes.logo}${useDarkBrand ? ' brandLogoDark' : ''}`}
                    style={{
                      width: otherImgWidth || '100%',
                    }}
                    alt="Deviare"
                    onClick={() => history.push(Paths.Dashboard)}
                    src={brandLogo}
                  />
                </div>
              </div>

              <div className={classes.searchBar}>
                <DynamicAutoSearch
                  open={searchOpen}
                  handleChange={(evt, newVal) => {
                    if (!newVal?.category) return;
                    window.location.href = `/skill-transformation/course-catalogue?category=${newVal.category}`;
                  }}
                  handleOpen={val => {
                    setSearchOpen(val);
                  }}
                  options={searchCourses}
                  handleSearch={handleGlobalSearch}
                  optLoading={optLoading}
                />
                {!isMobile && (
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={loading}
                    ref={menuRef}
                    aria-controls={menuOpen ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggleMenu}
                    className={`${classes.exploreButton}${menuOpen ? ` ${classes.exploreButtonOpen}` : ''}`}
                    endIcon={menuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                    Explore
                  </Button>
                )}
              </div>

              {/* Mobile Search Icon - Next to Logo */}
              <IconButton
                className={`${classes.searchIconButton} ${classes.iconBtn}${mobileSearchOpen ? ` ${classes.searchIconButtonActive}` : ''}`}
                onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>

              {/* Mobile Search Bar */}
              {mobileSearchOpen && (
                <div className={classes.searchBarMobile}>
                  <DynamicAutoSearch
                    open={searchOpen}
                    handleChange={(evt, newVal) => {
                      if (!newVal?.category) return;
                      window.location.href = `/skill-transformation/course-catalogue?category=${newVal.category}`;
                      setMobileSearchOpen(false);
                    }}
                    handleOpen={val => {
                      setSearchOpen(val);
                    }}
                    options={searchCourses}
                    handleSearch={handleGlobalSearch}
                    optLoading={optLoading}
                  />
                </div>
              )}
            </>
          ) : (
            <div className={classes.title}>
              <div className={`${classes.brandLogoWrap}${desktopLogoInSidebar ? ` ${classes.desktopBrandHidden}` : ''}`}>
                <img
                  loading="eager"
                  className={`${classes.logoAdmin}${useDarkBrand ? ' brandLogoDark' : ''}`}
                  alt="Deviare"
                  onClick={() => history.push(Paths.Dashboard)}
                  src={brandLogo}
                />
              </div>
            </div>
          )}

          {userRole === USER_ROLES.USER && (
            <div className={classes.rightMenuItem} aria-label="Learning navigation">
              {menu_items.map(menuItem => (
                <Typography
                  key={menuItem.name}
                  component="span"
                  className={`${classes.navSectionLink} ${isNavItemActive(menuItem.path) ? classes.navSectionLinkActive : ''}`}
                  onClick={() => history.push(menuItem.path)}
                  role="link"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      history.push(menuItem.path);
                    }
                  }}
                >
                  {menuItem.name}
                </Typography>
              ))}
            </div>
          )}

          <div className={classes.headerActions}>
            {userRole === USER_ROLES.USER && (
              <>
                {/* Mobile Icons Group - Three Dots and Apps Icon */}
                <div className={classes.mobileIconsGroup}>
                  {/* Mobile Menu Button (Three Dots) */}
                  <IconButton
                    ref={mobileMenuAnchorRef}
                    className={`${classes.mobileMenuButton} ${classes.iconBtn}`}
                    onClick={handleMobileMenuOpen}
                    aria-label="show more menu items"
                    aria-controls={mobileMenuOpen ? 'mobile-menu' : undefined}
                    aria-haspopup="true"
                  >
                    <MoreVertIcon style={{ color: variables.darkThemeText }} />
                  </IconButton>

                  {/* Mobile Explore Icon (Apps) - Next to Three Dots */}
                  <IconButton
                    ref={menuRef}
                    className={`${classes.exploreButtonMobile} ${classes.iconBtn}`}
                    onClick={handleToggleMenu}
                    aria-label="explore courses"
                    aria-controls={menuOpen ? 'explore-menu' : undefined}
                    aria-haspopup="true"
                  >
                    <AppsIcon style={{ color: variables.darkThemeText }} />
                  </IconButton>
                </div>
              </>
            )}
            <Tooltip title={mode === 'dark' ? 'Light mode' : 'Dark mode'}>
              <IconButton
                className={`${classes.iconBtn}${userRole === USER_ROLES.USER ? ` ${classes.userMobileUtility}` : ''}`}
                onClick={toggleColorMode}
                aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
              >
                {mode === 'dark' ? <WbSunnyIcon /> : <Brightness4Icon />}
              </IconButton>
            </Tooltip>
            {!isTinyScreen && (
              <Tooltip title="Notifications">
                <IconButton
                  className={`${classes.iconBtn}${userRole === USER_ROLES.USER ? ` ${classes.userMobileUtility}` : ''}`}
                  aria-label="Show notifications"
                >
                  <NotificationsIcon />
                </IconButton>
              </Tooltip>
            )}
            <IconButton
              ref={avatarAnchorRef}
              className={`${classes.iconBtn} ${classes.profileAvatarButton}`}
              aria-label="profile"
              onClick={handleToggle}
            >
              <Avatar
                imgProps={{ loading: 'eager' }}
                alt="Deviare"
                src={profileImageSrc}
                className={classes.profileAvatar}
              />
            </IconButton>
            <Button
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              className={classes.profileButton}
              style={{ color: variables.darkThemeText }}
              onClick={handleToggle}
              endIcon={<ExpandMoreIcon style={{ fontSize: 20 }} />}>
              <Avatar
                imgProps={{ loading: 'eager' }}
                alt="Deviare"
                src={profileImageSrc}
                className={classes.profileAvatar}
              />
              <span className={classes.profileButtonText}>
                {loggedInUser
                  ? `${loggedInUser.firstName} ${loggedInUser.lastName}`
                  : 'Profile'}
              </span>
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <Popper
        open={open}
        anchorEl={isMobile ? avatarAnchorRef.current : anchorRef.current}
        transition
        disablePortal
        placement="bottom-end"
        modifiers={{
          offset: {
            enabled: true,
            offset: '0, 10',
          },
        }}
        style={{ zIndex: 999 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            style={{
              transformOrigin:
                placement === 'bottom-end' ? 'right top' : 'right bottom'
            }}
            {...TransitionProps}>
            <Paper className={classes.profileMenuPaper} elevation={0}>
              <div className={classes.profileMenuHeader}>
                <div className={classes.profileImg}>
                  <img
                    loading="lazy"
                    decoding="async"
                    alt="user logo"
                    src={
                      profileLoading
                        ? userImg
                        : loggedInUser && loggedInUser.profile_image
                          ? loggedInUser.profile_image
                          : defaultImage
                    }
                    className={classes.largeImg}
                  />
                  <span
                    className={classes.editBack}
                    onClick={handleProfile}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleProfile();
                      }
                    }}
                    aria-label="Edit profile photo"
                  >
                    <EditIcon style={{ fontSize: 14 }} />
                  </span>
                </div>
                <Typography className={classes.profileMenuName}>
                  {loggedInUser
                    ? `${loggedInUser.firstName || ''} ${loggedInUser.lastName || ''}`.trim() || 'Profile'
                    : 'Profile'}
                </Typography>
                {(loggedInUser?.email || loggedInUser?.userName) ? (
                  <Typography className={classes.profileMenuEmail}>
                    {loggedInUser.email || loggedInUser.userName}
                  </Typography>
                ) : null}
              </div>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                  className={classes.profileMenuList}
                >
                  <MenuItem className={classes.profileMenuItem} onClick={handleProfile}>
                    <ListItemIcon className={classes.profileMenuItemIcon}>
                      <PersonOutlineIcon />
                    </ListItemIcon>
                    Edit Profile
                  </MenuItem>
                  {!impersonation.active && (
                  <MenuItem className={classes.profileMenuItem} onClick={handleChangePassword}>
                    <ListItemIcon className={classes.profileMenuItemIcon}>
                      <LockOutlinedIcon />
                    </ListItemIcon>
                    Change Password
                  </MenuItem>
                  )}
                  <MenuItem
                    className={`${classes.profileMenuItem} ${classes.profileMenuItemLogout}`}
                    onClick={handleLogout}
                  >
                    <ListItemIcon className={classes.profileMenuItemIcon}>
                      <ExitToAppIcon />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {/* Mobile Menu for Dashboard, In-progress, Completed */}
      {userRole === USER_ROLES.USER && (
        <Popper
          open={mobileMenuOpen}
          anchorEl={mobileMenuAnchorRef.current}
          transition
          disablePortal
          style={{ zIndex: 999 }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom'
              }}
              {...TransitionProps}
            >
              <Paper className={classes.mobileMenuPaper}>
                <ClickAwayListener onClickAway={handleMobileMenuClose}>
                  <MenuList
                    autoFocusItem={mobileMenuOpen}
                    id="mobile-menu"
                    style={{ padding: theme.spacing(1) }}
                    onKeyDown={(e) => {
                      if (e.key === 'Tab') {
                        e.preventDefault();
                        handleMobileMenuClose();
                      }
                    }}
                  >
                    {menu_items.map((menuItem) => (
                      <MenuItem
                        key={menuItem.name}
                        onClick={() => handleMobileMenuItemClick(menuItem.path)}
                        className={`${classes.mobileNavMenuItem} ${isNavItemActive(menuItem.path) ? classes.mobileNavMenuItemActive : ''}`}
                        style={{
                          color: isNavItemActive(menuItem.path) ? '#3C7DDD' : variables.darkThemeText,
                        }}
                      >
                        {menuItem.name}
                      </MenuItem>
                    ))}
                    {isCompactMobile && (
                      <MenuItem
                        onClick={() => {
                          toggleColorMode();
                          handleMobileMenuClose();
                        }}
                        className={classes.mobileNavMenuItem}
                        style={{ color: variables.darkThemeText }}
                      >
                        <ListItemIcon className={classes.profileMenuItemIcon}>
                          {mode === 'dark' ? <WbSunnyIcon /> : <Brightness4Icon />}
                        </ListItemIcon>
                        {mode === 'dark' ? 'Light mode' : 'Dark mode'}
                      </MenuItem>
                    )}
                    {isCompactMobile && (
                      <MenuItem
                        onClick={handleMobileMenuClose}
                        className={classes.mobileNavMenuItem}
                        style={{ color: variables.darkThemeText }}
                      >
                        <ListItemIcon className={classes.profileMenuItemIcon}>
                          <NotificationsIcon />
                        </ListItemIcon>
                        Notifications
                      </MenuItem>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}

      {userRole === USER_ROLES.USER && (
        <Popper
          open={menuOpen}
          anchorEl={menuRef.current}
          transition
          disablePortal={!isMobile}
          placement={isMobile ? "bottom-end" : "bottom-start"}
          modifiers={{
            offset: {
              enabled: true,
              offset: '0, 8',
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'viewport',
            },
          }}
          style={{
            zIndex: 1300,
            width: isMobile
              ? 'calc(100vw - 16px)'
              : 'min(960px, calc(100vw - 48px))',
          }}>
          {({ TransitionProps, placement }) => (
            <Grow
              style={{
                transformOrigin: placement.startsWith('bottom')
                  ? 'center top'
                  : 'center bottom'
              }}
              {...TransitionProps}>
              <Paper className={classes.explorePanel} elevation={0}>
                <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                  <div>
                    <div className={classes.explorePanelHeader}>
                      <div>
                        <Typography className={classes.explorePanelEyebrow}>
                          Course catalogue
                        </Typography>
                        <Typography className={classes.explorePanelTitle}>
                          Explore courses
                        </Typography>
                        <Typography className={classes.explorePanelDescription}>
                          Browse categories and jump into a course, or open the full catalogue.
                        </Typography>
                      </div>
                    </div>
                    <div className={classes.menuContainer}>
                      {courseCatalogueList.map(courseItem => (
                          <div key={courseItem.category} className={classes.menuContainerItem}>
                            <Button
                              className={classes.header}
                              title={courseItem.category}
                              onClick={() => handleSubManuClicked(courseItem)}
                              style={{ textTransform: 'none', justifyContent: 'flex-start', padding: 0 }}
                            >
                              {courseItem.category}
                            </Button>
                          </div>
                      ))}

                      <div className={classes.lastRow}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.browseAll}
                          disableElevation
                          onClick={() => handleSubManuClicked()}
                        >
                          Browse all courses
                        </Button>
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </div>
  );
};

export default Header;
